import { render } from "./HighSchoolScoreVsCurrentGpa.vue?vue&type=template&id=2c96d999"
import script from "./HighSchoolScoreVsCurrentGpa.vue?vue&type=script&lang=js"
export * from "./HighSchoolScoreVsCurrentGpa.vue?vue&type=script&lang=js"
script.render = render

export default script